import React, { useState } from 'react';
import { FiX, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './ProductCarousel.css';

export interface CarouselScreen {
  image: string;
  description: string;
}

interface ProductCarouselProps {
  productName: string;
  screens: CarouselScreen[];
  onClose: () => void;
}

const ProductCarousel: React.FC<ProductCarouselProps> = ({ productName, screens, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? screens.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === screens.length - 1 ? 0 : prev + 1));
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (screens.length === 0) return null;

  return (
    <div className="carousel-modal" onClick={handleBackdropClick}>
      <div className="carousel-modal__content">
        <button className="carousel-modal__close" onClick={onClose}>
          <FiX size={24} />
        </button>

        <h2 className="carousel-modal__title">{productName}</h2>

        <div className="carousel-modal__slider">
          <button 
            className="carousel-modal__nav carousel-modal__nav--prev" 
            onClick={goToPrevious}
            aria-label="Previous screen"
          >
            <FiChevronLeft size={32} />
          </button>

          <div className="carousel-modal__slide">
            <img
              src={screens[currentIndex].image}
              alt={`${productName} screen ${currentIndex + 1}`}
              className="carousel-modal__image"
            />
            {screens[currentIndex].description && (
              <p className="carousel-modal__description">
                {screens[currentIndex].description}
              </p>
            )}
          </div>

          <button 
            className="carousel-modal__nav carousel-modal__nav--next" 
            onClick={goToNext}
            aria-label="Next screen"
          >
            <FiChevronRight size={32} />
          </button>
        </div>

        <div className="carousel-modal__dots">
          {screens.map((_, index) => (
            <button
              key={index}
              className={`carousel-modal__dot ${index === currentIndex ? 'carousel-modal__dot--active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to screen ${index + 1}`}
            />
          ))}
        </div>

        <div className="carousel-modal__counter">
          {currentIndex + 1} / {screens.length}
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
